const URL_APP = process.env.VUE_APP_URL_API_V2;

export default URL_APP
